import { get, isEmpty, findKey, startsWith } from 'lodash';
const OLD_IMAGE_TYPE = 'IMAGE';
const IMAGE_TYPE = 'wix-draft-plugin-image';
const GALLERY_TYPE = 'wix-draft-plugin-gallery';
const ALL_IMAGE_ENTITY_TYPES = [OLD_IMAGE_TYPE, IMAGE_TYPE, GALLERY_TYPE];
const OLD_VIDEO_EMBED_TYPE = 'VIDEO-EMBED';
const VIDEO_EMBED_TYPE = 'wix-draft-plugin-video';
const ALL_VIDEO_EMBED_ENTITY_TYPES = [OLD_VIDEO_EMBED_TYPE, VIDEO_EMBED_TYPE];
export const getCustomCoverImage = (post) => {
    const { isEnabled = true, isCustom = true, src } = get(post, 'coverImage', {}) || {};
    return isEmpty(src)
        ? { isEnabled, isCustom: false }
        : {
            isEnabled,
            imageMetadata: src,
            isCustom,
        };
};
export const getResolvedCoverImage = (post) => {
    const { isResolved, ...props } = post.coverImage || {};
    return isResolved === true ? props : undefined;
};
const getPostContentEntityMap = (post) => get(post, 'content.entityMap', {});
function numberOrZero(number) {
    return Number(number) || 0;
}
const getCoverFromImage = (entity) => {
    const src = get(entity, 'data.src');
    if (src && src.fallback) {
        return {
            file_name: src.file_name || src.fallback,
            width: numberOrZero(src.width),
            height: numberOrZero(src.height),
        };
    }
    else {
        return src;
    }
};
const getCoverFromGallery = (entity) => {
    const item = get(entity, 'data.items[0]');
    return item
        ? {
            file_name: item.url,
            width: item.metadata ? item.metadata.width : 0,
            height: item.metadata ? item.metadata.height : 0,
        }
        : {};
};
export const getPostImageCover = (post) => {
    const entities = getPostContentEntityMap(post);
    const key = findKey(entities, (entity) => ALL_IMAGE_ENTITY_TYPES.indexOf(entity.type) > -1);
    const entity = entities[key];
    return entity ? getCoverFromImage(entity) || getCoverFromGallery(entity) : undefined;
};
const OEMBED_PATH = {
    [OLD_VIDEO_EMBED_TYPE]: 'data.oembed',
    [VIDEO_EMBED_TYPE]: 'data.metadata.oembed',
};
const getCoverFromOembed = (entity) => {
    if (!get(entity, `${OEMBED_PATH[entity.type]}.thumbnail_url`)) {
        return undefined;
    }
    const path = get(entity, OEMBED_PATH[entity.type]);
    if (startsWith(path.thumbnail_url, '//')) {
        return { ...path, thumbnail_url: `https:${path.thumbnail_url}` };
    }
    return path;
};
const getCoverFromVideo = (entity, { resizeThumbnail, getVideoUrl }) => {
    if (!(resizeThumbnail && getVideoUrl)) {
        return undefined;
    }
    const video = get(entity, 'data.src');
    const thumbnail = get(entity, 'data.src.thumbnail');
    if (!thumbnail) {
        return undefined;
    }
    const resized = resizeThumbnail(thumbnail.pathname, thumbnail.width, thumbnail.height);
    return {
        thumbnail_url: resized.url,
        thumbnail_height: resized.height,
        thumbnail_width: resized.width,
        video_url: getVideoUrl(video.pathname),
    };
};
export const getPostVideoEmbedCover = (post, helpers = {}) => {
    const entities = getPostContentEntityMap(post);
    const key = findKey(entities, (entity) => ALL_VIDEO_EMBED_ENTITY_TYPES.includes(entity.type) &&
        (get(entity, `${OEMBED_PATH[entity.type]}.thumbnail_url`) ||
            get(entity, 'data.src.thumbnail')));
    const entity = entities[key];
    return entity ? getCoverFromOembed(entity) || getCoverFromVideo(entity, helpers) : undefined;
};
export const getPostCover = (post, helpers = {}) => {
    const resolvedCoverImage = getResolvedCoverImage(post);
    if (resolvedCoverImage) {
        return resolvedCoverImage;
    }
    // eslint-disable-next-line prefer-const
    let { imageMetadata, isCustom, isEnabled } = getCustomCoverImage(post);
    let videoMetadata;
    if (!imageMetadata) {
        imageMetadata = getPostImageCover(post);
    }
    if (!imageMetadata) {
        videoMetadata = getPostVideoEmbedCover(post, helpers);
    }
    return {
        shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
        imageMetadata,
        videoMetadata,
        src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
        isEnabled,
        isCustom,
    };
};
//# sourceMappingURL=get-post-cover-deprecated.js.map